import { angleFromPoint, polarToCartesian } from './functions';
import map from '@/libs/lygia/math/map.glsl';

export const glslSpeedLines = /*glsl*/ `
    ${polarToCartesian}
    ${angleFromPoint}
    ${map}

    // Speed lines: twist the noise texture around the center
    float speedLines(
        sampler2D noiseMap,
        vec2 uv,
        float time,
        float radiusScale,
        float angleScale
    ) {
        // Center UV
        vec2 p = uv - 0.5;
        float radius = length(p);
        radius *= radiusScale;

        float angle = angleFromPoint(p);
        angle = map(angle, -PI, PI, 0.0, 1.0);
        angle *= angleScale;

        float speed = time * -0.2;

        // Sample the noise texture at the warped coordinates
        vec2 radialUv = vec2(angle, radius + speed);
        float result = texture2D(noiseMap, radialUv).r;

        return result;
    }
`;
